export default "__VITE_ASSET__DpWAPqgV__"